module.exports = __webpack_public_path__ + "static/media/bagan-myanmar.445cc739.jpg";